// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemsList_wrapper__kXulW"};